import storeHelper from '@/helpers/store'

const storeObject = { ...storeHelper.generateStore('Subjects') }

storeObject.state = {
	...storeObject.state,
	subjectsByName: {},
}

storeObject.mutations = {
	...storeObject.mutations,
	SET_SUBJECTS_LIST: function (state, list) {
		state.subjectsList = list
		state.subjectsList.forEach((subject) => {
			const subjectName = subject.name
			state.subjectsByName[subjectName] =
				state.subjectsByName[subjectName] || subject
		})
	},
}

export default {
	...storeObject,
}
